module.exports = __webpack_public_path__ + "static/trees_night-1a0a6a0504baef39c820318b0a8b5c9d.jpg";